import { HeaderText2TW } from "../../../../../../tailwindComponents/HeaderTextTW/HeaderTextTW";
import { BodyTextTW } from "../../../../../../tailwindComponents/bodyText/BodyTextTW";
import { ButtonTW } from "../../../../../../tailwindComponents/buttonTW/ButtonTW";
import React from "react";

export const Corrections = ({ corrections, onClose }: { corrections: string[]; onClose: () => void }) => {
  return (<div className={'flex flex-col gap-5 p-2'}>
    <section>
      <HeaderText2TW>Signature Sync Corrections</HeaderText2TW>
    </section>
    <section className={'flex flex-col gap-2'}>
      <BodyTextTW>The following corrections must be done before integrating this signing appointment with Signature
        Sync:</BodyTextTW>
      <div>
        <ul className={'list-disc list-inside p-3'}>
          {corrections.map(correction => (<li className={'text-red-500'}>
            {correction}
          </li>))}
        </ul>
      </div>
    </section>
    <section className={'flex justify-end'}>
      <ButtonTW onClick={onClose}>Ok</ButtonTW>
    </section>
  </div>)
}